import { Outcome } from './outcome';

export interface Action {
  actionType?: string;
  attempt?: number;
  batchId?: number;
  campaignId?: number;
  cbDatetime?: Date;
  clientNotes?: string;
  completed?: boolean;
  contactId?: number;
  contactUtcOffset?: number;
  datetime?: Date;
  dnis?: string;
  dtUploaded?: Date;
  duration?: number;
  endTime?: Date;
  historical?: boolean;
  invoiceId?: number;
  killMonitor?: boolean;
  notes?: string;
  numberUsed?: string;
  outcome?: Outcome;
  queueId?: number;
  rateRevenue?: number;
  rateUser?: number;
  release?: number;
  sessionId?: string;
  startTime?: Date;
  userUtcOffset?: number;
  versionId?: number;
  workId?: number;
}

export type ActionValidation = {
  [key in keyof Action]: { maxLength: number };
};

export const actionValidation: ActionValidation = {
  outcome: { maxLength: 50 },
};
